/** Dependencies */
import { useEffect, useState } from 'react';

/** Components */
import FilterString from './../../Filters/FilterString';
import DropDownMenu from './../../Filters/DropDownMenu';

/** Helpers */
import { deepEqual } from './../../../helpers/functions';

function Keywords( props )
{
  const {
    id,
    pictoTitle,
    filterLabel,
    autoCompletedValues,
    dropDownMenuKeywordsGroupsValues,
    initFilterValues,
    callBackFunction
  } = props;

  /** Init State */
  const [ filterValues, setFilterValues ] = useState( initFilterValues !== null ? initFilterValues : null );

  /** Update Range filter values */
  useEffect( () => 
  {
    // callback function if filter values not null
    if( 
      filterValues !== null 
      && typeof callBackFunction === 'function' 
      && !deepEqual( filterValues, initFilterValues )
    )
      callBackFunction( filterValues );

  }, [ filterValues ] )

  return(
    <div className='filter-container keywords'>

      {/* Title */}
      <h4 className='picto-title'>
        { pictoTitle }
        { filterLabel }
      </h4>

      {/* Filter string on keywords */}
      <FilterString
        id={ id + '-string' }
        filterLabel={ filterLabel }
        inputLabel={ filterLabel }
        autoCompletedValues={ autoCompletedValues }
        initCurrentValues={ filterValues !== null && filterValues.value ? filterValues.value : null }
        callBackFunction={ values => setFilterValues( { ...filterValues, value: values } ) }
      />

      {/* Filter drop down menu on keywords groups */}
      { dropDownMenuKeywordsGroupsValues !== null && dropDownMenuKeywordsGroupsValues.length > 0 ?
        <DropDownMenu
          id={ id + '-dropdown-menu-keywords-groups' }
          label="Groupes de mots-clés"
          dropDownMenuValues={ dropDownMenuKeywordsGroupsValues.sort().map( elem => ({ label: elem, value: elem })) }
          initCurrentValues={ filterValues !== null && filterValues.keywordsGroups ? filterValues.keywordsGroups : null }
          callBackFunction={ values => setFilterValues( { ...filterValues, keywordsGroups: values } ) }
        />
        : null
      }

    </div>
  )
}

export default Keywords;